var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sample-mutation mt-n4",attrs:{"id":_vm.sample_mutation_id}},[_c('svg')])}
var staticRenderFns = []

export { render, staticRenderFns }